import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient } from "@angular/common/http";
import { RestApi } from "src/app/shared/RestApi/restApi";
import { map } from 'rxjs/operators';

interface permissionsDetails {
  message: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
/*
Author:Ravi G
Date:28-06-2022
*/
export class CommonPermissionService {

  constructor(private spinner: NgxUiLoaderService, private Http: HttpClient, private rest: RestApi) { }
  // reterive screens to user have permission
  retrieveWeb(userId) {

    console.log(userId);

    var screentype = "web"

    console.log(this.rest.retrievePermissionNames+ "/" + screentype + "/" + userId);

    console.log(screentype);

    console.log(userId);

    this.spinner.start();

    return this.Http.get<permissionsDetails>(this.rest.retrievePermissionNames + "/" + screentype + "/" + userId).pipe(
      map(res => {
        //Changed by nikhil 25-11-2019
        //Now it is dynamically connected to database
        console.log(res);
      
        var parentChildPermissions = [];
        if (res.error == true) {
          this.spinner.stop();
          return false;
        }
        else {
          this.spinner.stop();
          var permissionNames: any = [];
          //Stroing response into permissionNames
          permissionNames = res;
          console.log(permissionNames);
          var permissionAllAccess;
          //Storing Yes or No into permissionAllAccess
          permissionNames.filter(permissionNames => {

            console.log("permissionNames");

            if (1001 === permissionNames.screenId && "Yes" === permissionNames.access) {
              permissionAllAccess = permissionNames;
            }
            if (1001 === permissionNames.screenId && "No" === permissionNames.access) {
              permissionAllAccess = permissionNames;
            }
          });
          console.log(permissionAllAccess);
          console.log(permissionAllAccess.access);
          //permissionNames are adding to anotherPermissionNames without 1001 screenId
          var anotherPermissionNames = permissionNames.filter(permissionNames => 1001 !== permissionNames.screenId);
          console.log(anotherPermissionNames);
          var parentChildNames;
          //It will execute when all permissions are not given
          if (permissionAllAccess.access != 'Yes') {
            parentChildNames = anotherPermissionNames.filter(permissionNames => "Yes" === permissionNames.access);
          }
          else {
            parentChildNames = anotherPermissionNames;
          }
          var permissionsLength = parentChildNames.length;
          //Separting child and parent by using level
          var parentNames = parentChildNames.filter(permissionNames => 1 === permissionNames.level);
          var parentNamesTemporary = [];

          parentNames.filter(parentNamesTemp => {

            parentNamesTemporary.push({});

          });

          parentNames.filter(parentNamesTemp => {

            console.log(parentNamesTemp["morder"] - 1);

            parentNamesTemporary[parentNamesTemp["morder"] - 1] = parentNamesTemp;

          });

          parentNames = parentNamesTemporary;
          var childNames = parentChildNames.filter(permissionNames => 2 === permissionNames.level);
          console.log(parentNames);
          console.log(childNames);
          //Combining parent and child
          parentNames.filter(parentPermission => {
            var childPermissionNames = [];
            childNames.filter(childPermission => {
              if (childPermission.parentScreenId === parentPermission.screenId) {
                childPermissionNames.push(childPermission)
              }
            });
            parentPermission["child"] = childPermissionNames;
            console.log(parentPermission);
            console.log(parentPermission);
            parentChildPermissions.push(parentPermission)
          });
          console.log(parentChildPermissions);
        }
        return [permissionsLength, parentChildPermissions];
      }),
    );
  }

}
